<template>
  <div class="text-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" :key="ids.rect_id"/>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="滚动条设置" name="3" v-if="isShowScroll">
<!--          <div class="data-source-type">-->
<!--            <el-radio v-model="noCacheComponent" :label="labelFalse">无</el-radio>-->
<!--            <el-radio v-model="noCacheComponent" :label="labelTrue">自定义</el-radio>-->
<!--          </div>-->
<!--          <div class="img_up content flex" v-show="noCacheComponent">-->
<!--            <el-input-->
<!--              type="text"-->
<!--              class="mb8"-->
<!--              v-model="iframeUrl"-->
<!--              placeholder="请输入http://或https://开头的地址"-->
<!--            ></el-input>-->
<!--          </div>-->
          <div class="iframe-scroll-setting">
            <span class="mr16">显示滚动条</span>
            <div class="data-source-type">
              <el-radio v-model="iframeScrollStatus" :label="labelTrue">显示</el-radio>
              <el-radio v-model="iframeScrollStatus" :label="labelFalse">隐藏</el-radio>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="背景" name="3">
          <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
        </el-collapse-item>
        <el-collapse-item title="边框" name="4">
          <div>
            <div class="content-item verticallyCenter mb12">
              <el-checkbox v-model="showBorder">显示边框</el-checkbox>
            </div>
            <cx-border
              v-if="showBorder"
              :borderWidth.sync="borderWidth"
              :borderStyle.sync="borderStyle"
              :borderColor.sync="borderColor"
              :borderIsThemeColor.sync="borderIsThemeColor"
            />
          </div>
          <div class="content-item mt12">
            <border-radius
              :borderTypeFlag.sync="borderTypeFlag"
              :borderRadius.sync="borderRadius"
              :borderTopLeftRadius.sync="borderTopLeftRadius"
              :borderTopRightRadius.sync="borderTopRightRadius"
              :borderBottomRightRadius.sync="borderBottomRightRadius"
              :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              :sliderMax="borderRadiusMax"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="5">
          <cx-padding
            :paddingTypeFlag.sync="textPaddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
          />
        </el-collapse-item>
        <el-collapse-item title="更多" name="6">
          <div class="content">
            <widthAndSizeAndZindex
              :options="options"
              :ids="ids"
              showSetItem="rotate"
              v-if="request_prefix !== 'bigScreen'"
            />
            <div class="content-item mt12">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <div class="content-item mt12">
              <public-style :options="options" :ids="ids"></public-style>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>尺寸用于调整组件容器的大小：</span
        >支持px（像素）和百分比两种设置方式。设置的百分比是指组件宽高占所在容器宽高的百分比。
      </p>
      <div class="box">
        <video src="https://mh.chaoxing.com/sv2/assets/video/size.mp4" controls></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import defaultImgBg from "assets/images/empty_img_bg.png"
import dataToolMixin from "materials/dataToolMixin"
import publicStyle from "publicSetting/publicStyle.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"

export default {
  name: "iframe-options-data",
  mixins: [dataToolMixin],
  components: {
    TextSettingComplex,
    controlWidthAndSizeAndZindex,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue"),
    publicStyle,
    widthAndSizeAndZindex
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      this1: this,
      collapseActiveNames: [],
      sliderMax: 360,
      paddingMax: 200,
      borderRadiusMax: 1000,
      defaultImgBg: defaultImgBg,
      labelTrue: true,
      labelFalse: false,
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      explainDialog: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    iframeUrl: {
      get() {
        return this.options.iframeUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iframeUrl", false)
      }
    },
    iframeScrollStatus: {
      get() {
        return this.options.iframeScrollStatus
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iframeScrollStatus", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
      }
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    left: {
      get() {
        return this.fixGetNumber("left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "left", false)
      }
    },
    top: {
      get() {
        return this.fixGetNumber("top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "top", false)
      }
    },
    width: {
      get() {
        return this.fixGetNumber("width")
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.$changeOptionsEV(newVal, "width", false)
      }
    },
    height: {
      get() {
        return this.fixGetNumber("height")
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.$changeOptionsEV(newVal, "height", false)
      }
    },
    widthType: {
      get() {
        return this.options.widthType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthType", false)
      }
    },
    heightType: {
      get() {
        return this.options.heightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "heightType", false)
      }
    },
    isShowScroll(){
      if(!this.ids.hasOwnProperty("elementInLayoutId")){
        return true
      }
      if(this.isInLoginLayout){
        return false
      }else{
        return  true
      }
    },
    isInLoginLayout() {
      if (
        this.layoutOptions?.pluginName &&
        (this.layoutOptions?.pluginName.includes("loginLayoutComponent") ||
        this.layoutOptions?.pluginName.includes("loginEngineComponentPlugin") ||
          this.layoutOptions?.pluginName.includes("searchComponentPlugin"))
      ) {
        return true
      } else {
        return false
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    borderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderColor", "borderColor", "#3D82F2")
      },
      set(val) {
        this.$changeOptionsEV(val, "borderColor", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (Array.isArray(this.options.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.borderWidth.length; i++) {
              if (this.options.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.showBorder
        }
        return this.checkAndSetPrimaryVal(this.options, "showBorder", "showBorder", showBorder)
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(val) {
        this.$changeOptionsEV(val, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderStyle", "borderStyle", "solid")
      },
      set(val) {
        this.$changeOptionsEV(val, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "borderIsThemeColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    // 边距
    textPaddingTypeFlag: {
      get() {
        let defaultType = 2
        return this.checkAndSetPrimaryVal(this.options, "textPaddingTypeFlag", "textPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowColor", "boxShadowColor", ["rgba(255,255,255,1)"])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowH", "boxShadowH", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowV", "boxShadowV", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowBlur", "boxShadowBlur", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowSpread", "boxShadowSpread", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    fixGetNumber(name) {
      const num = this.options[name]
      if (String(num).includes(".")) {
        return String(num).split(".")[1].length > 2 ? num.toFixed(2) : num
      } else {
        return num
      }
    },
    leftTypeHandleCommand(val) {
      if (this.leftType === val) {
        return
      }
      this.leftType = val
      this.left = 0
      this.margin = null
      this.offset = null
    },
    topTypeHandleCommand(val) {
      if (this.topType === val) {
        return
      }
      this.topType = val
      this.top = 0
      this.margin = null
      this.offset = null
    },
    widthTypeHandleCommand(val) {
      if (this.widthType === val) {
        return
      }
      this.widthType = val
      this.width = val === "%" ? 100 : 200
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      this.heightType = val
      this.height = val === "%" ? 100 : 200
    }
  }
}
</script>

<style scoped>
.el-radio {
  margin-bottom: 0px !important;
}

.img_up {
  margin-top: 16px;
}
.video-start-btn-setting {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}

.flex_box {
  display: flex;
  align-items: center;
}

.data-source-type .bigScreen .toolbar .el-radio__label {
  margin-left: 0px;
}
.dialog-play-mode > span {
  display: inline-block;
  vertical-align: top;
}

.dialog-play-mode .data-source-type {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 72px);
}

.video-border-setting > div:first-child {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 40px);
}
.video-border-color {
  display: inline-block;
  vertical-align: bottom;
  width: 32px;
  margin-left: 8px;
}
.video-border-color ::v-deep .text_color_in_input {
  display: none;
}
.bigScreen .toolbar .dialog-play-setting ::v-deep .el-radio__label {
  margin-left: 0;
}

.iframe-scroll-setting {
  font-size: 0;
}
.iframe-scroll-setting > span {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
}
.iframe-scroll-setting .data-source-type {
  display: inline-block;
  vertical-align: middle;
}

.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}

.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}
.color000 {
  color: var(--text);
}
::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}
::v-deep .input-size .el-input__suffix {
  right: 4px;
}
::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}
::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 90px;
  padding-left: 36px;
}
.el-dropdown-menu__item {
  color: var(--textColor);
}
</style>
